<template>
  <!-- Single root element containing all other elements -->
  <div class="dashborad mt-[7%]" v-if="hasDashboardPermission">
    <loading
      v-model:active="pageLoader"
      :can-cancel="false"
      loader="dots"
      color="#02C782"
      background-color="#818585"
      width="130"
      height="130"
      :is-full-page="true"
    />
    <div class="px-5 pt-0 mx-auto">
      <diV class="flex flex-wrap items-start justify-between py-5 filter">
        <div>
          <h1
            style="font-weight: 600"
            class="flex font-family-card pb-6 text-[27px]"
          >
            Status of Waste Collected vs Disposed
          </h1>
          <div class="flex flex-wrap justify-between">
            <select
              @change="fetchDistrict"
              v-model="selectDistrictid"
              style="width: 200px; height: 40px; font-weight: 400px"
              id="selectDistrictid"
              class="font-family-card text-[16px] font-semibold rounded-lg border bg-white mr-3 mb-5 md:mb-0 border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option selected value="all">All Cities</option>
              <option
                v-for="district in selectDistrict"
                :key="district.id"
                :value="district.id"
              >
                {{ district.name }}
              </option>
            </select>
            <select
              ref="hospitalsSelect1"
              multiple
              v-model="counteryid"
              id="hospitalsSelect1"
              style="width: 300px; height: 40px; background: white"
              class="js-example-disabled-results bg-white rounded-lg border mt-5 md:pt-0 mr-3 border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value=""></option>
              <option
                v-for="hospital in countries"
                :key="hospital.id"
                :value="hospital.id"
              >
                {{ hospital.name }}
              </option>
            </select>
            <div class="flex" style="display: ">
              <div
                style="height: 40px"
                class="flex md:pt-0 pt-5 items-center ps-4 dark:border-gray-700"
              >
                <router-link
                  to=""
                  @click="clearFilter"
                  class="font-family-card rounded-lg border text-border border-border hover:bg-border hover:text-white hover:bg-bg-hover-save focus:ring-4 focus:ring-blue-300 font-medium text-sm px-9 py-2 md:py-2.5 dark:bg-regal-blue focus:outline-none dark:focus:ring-blue-800"
                >
                  Clear
                </router-link>
              </div>
              <div
                style="width: 130px; height: 40px"
                class="flex md:pt-0 pt-5 ml-5 md:ml-0 items-center md:ps-4 dark:border-gray-700"
              >
                <router-link
                  to=""
                  @click="applyFilters"
                  class="font-family-card text-white rounded-lg bg-bg-save hover:bg-bg-hover-save focus:ring-4 focus:ring-blue-300 font-medium text-sm px-5 py-2 md:py-2.5 dark:bg-regal-blue focus:outline-none dark:focus:ring-blue-800"
                >
                  Apply Filter
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div
          class="card flex xl:mt-0 mt-5 overflow-hidden rounded-lg border p-5 bg-current-day-card"
        >
          <span
            style="font-weight: 700; font-size: 24.57px"
            class="pr-10 pt-4 font-family-card text-white text-2xl"
            >Current Day <br />
            <span class="text-white flex justify-center text-lg"
              >(KG,s)</span
            ></span
          >
          <div class="">
            <div
              class="font-normal w-[200px] text-[16px] border-dotted border-b-2 flex justify-between text-white dark:text-gray-400"
            >
              <h1>Collected</h1>
              <h1>{{ formatNumber(cardData.currentDateCollectionCount) }}</h1>
            </div>

            <div
              class="font-normal pt-3 text-[16px] flex justify-between text-white dark:text-gray-400"
            >
              <h1>Disposed</h1>
              <h1>{{ formatNumber(cardData.currentDateIncinerationCount) }}</h1>
            </div>
          </div>
        </div>
      </diV>
      <div class="w-full mx-auto flex flex-wrap justify-between items-center">
        <div
          class="card w-full lg:w-[44%] border-2 border-color py-[8px] rounded-lg bg-white lg:mt-0"
        >
          <Card :cardData="cardData" />
        </div>
        <div
          class="chart lg:w-[55%] w-full border-color border-2 pb-5 rounded-lg bg-white px-0 md:px-1 lg:py- mt-6 lg:mt-1"
        >
          <swiper
            :autoplay="{
              delay: 20000,
              disableOnInteraction: false,
            }"
            :effect="'fade'"
            class="bg-white"
            :pagination="pagination"
            :navigation="true"
            :modules="modules"
            :space-between="50"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide v-for="(tab, index) in tabs" :key="index">
              <div v-if="tab === 'currenttill'">
                <CurrentTillDate
                  v-if="activeTab === 'currenttill'"
                  :cardData="cardData"
                />
              </div>
              <div v-if="tab === 'currentyear'">
                <BarChart
                  v-if="activeTab === 'currentyear'"
                  :cardData="cardData"
                />
              </div>

              <div v-if="tab === 'currentmonth'">
                <CurrentMonth
                  v-if="activeTab === 'currentmonth'"
                  :cardData="cardData"
                />
              </div>
              <div v-if="tab === 'currentweek'">
                <currentWeek
                  v-if="activeTab === 'currentweek'"
                  :cardData="cardData"
                />
              </div>

              <div v-if="tab === 'currentday'">
                <CurrentDay
                  v-if="activeTab === 'currentday'"
                  :cardData="cardData"
                />
              </div>
              <!-- <div v-if="tab === 'currenttillprogress'">
                <CurrentTillProgress v-if="activeTab === 'currenttillprogress'" :cardData="cardData" />
              </div> -->
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="w-full border-2 border-color rounded-lg mb-6 bg-white mt-6">
        <TrandingGraph :tranding="tranding" />
      </div>

      <!-- Provincial Status - Incinerator Performance -->
      <div class="flex flex-wrap justify-between mb-15 pt-10">
        <h1
          style="font-weight: 600"
          class="text-black font-family-card text-[27px]"
        >
          Provincial Status - Disposal Performance
        </h1>
        <div class="flex flex-wrap justify-between">
          <select
            @change="fetchDistrictIn"
            v-model="selectDistrictidIn"
            style="width: 200px; height: 40px; font-weight: 400px"
            id="selectDistrictid"
            class="font-family-card text-[16px] rounded-lg border font-semibold bg-white mb-5 md:mb-0 mr-3 border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option selected value="all">All Cities</option>
            <option
              v-for="district in selectDistrictIN"
              :key="district.id"
              :value="district.id"
            >
              {{ district.name }}
            </option>
          </select>
          <!-- <SelectHosptialIncinerated /> -->
          <select
            ref="hospitalsSelect2"
            multiple
            v-model="counteryid"
            id="hospitalsSelect2"
            style="width: 300px; height: 40px; background: gray"
            class="js-example-disabled-results mt-5 md:mt-0 bg-gray-50 rounded-lg border mr-3 border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value=""></option>
            <option
              v-for="hospital in countriesiN"
              :key="hospital.id"
              :value="hospital.id"
            >
              {{ hospital.name }}
            </option>
          </select>
          <div class="flex md:pt-0 sm:pt-0 sm:pb-0 pb-2 pt-2" style="display: ">
            <div
              style="height: 40px"
              class="flex md:pt-0 pt-5 items-center ps-4 dark:border-gray-700"
            >
              <router-link
                to=""
                @click="clearFilterIn"
                class="font-family-card rounded-lg border text-border border-border hover:bg-border hover:text-white hover:bg-bg-hover-save focus:ring-4 focus:ring-blue-300 font-medium text-sm px-9 py-2 md:py-2.5 dark:bg-regal-blue focus:outline-none dark:focus:ring-blue-800"
              >
                Clear
              </router-link>
            </div>
            <div
              style="width: 130px; height: 40px"
              class="flex md:pt-0 pt-5 ml-5 md:ml-0 items-center md:ps-4 dark:border-gray-700"
            >
              <router-link
                to=""
                @click="applyFiltersincineration"
                class="font-family-card text-white rounded-lg bg-bg-save hover:bg-bg-hover-save focus:ring-4 focus:ring-blue-300 font-medium text-sm px-5 py-2 md:py-2.5 dark:bg-regal-blue focus:outline-none dark:focus:ring-blue-800"
              >
                Apply Filter
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w-full mx-auto flex md:mt-10 mt-5 flex-wrap justify-between items-start pb-[100px]"
      >
        <div
          class="chart lg:w-[55%] w-full border-2 border-color rounded-lg bg-white md:px-5 px-1 pt-5 pb-3 mt-6 lg:mt-0"
        >
          <swiper
            class="bg-white"
            :autoplay="{
              delay: 20000,
              disableOnInteraction: false,
            }"
            :pagination="pagination"
            :effect="'fade'"
            :navigation="true"
            :modules="modules"
            :space-between="50"
            @swiper="onSwiper"
            @slideChange="onSlideChange2"
          >
            <swiper-slide v-for="(tab, index) in tabIn" :key="index">
              <div v-if="tab === 'currentTillDateIncinerated'">
                <CurrentTillDateIncinerated
                  v-if="actibetabIn === 'currentTillDateIncinerated'"
                  :cardDataincineration="cardDataincineration"
                />
              </div>
              <div v-if="tab === 'currentTillDates'">
                <incineratedPieChart
                  v-if="actibetabIn === 'currentTillDates'"
                  :cardDataincineration="cardDataincineration"
                />
              </div>
              <div v-if="tab === 'currentMontIncinerated'">
                <CurrentMonthIncinerated
                  v-if="actibetabIn === 'currentMontIncinerated'"
                  :cardDataincineration="cardDataincineration"
                />
              </div>
              <div v-if="tab === 'currentWeekIncinerated'">
                <CurrentWeekIncinerated
                  v-if="actibetabIn === 'currentWeekIncinerated'"
                  :cardDataincineration="cardDataincineration"
                />
              </div>

              <div v-if="tab === 'CurrentDateIncineratedChart'">
                <CurrentDateIncineratedChart
                  v-if="actibetabIn === 'CurrentDateIncineratedChart'"
                  :cardDataincineration="cardDataincineration"
                />
              </div>
            </swiper-slide>
          </swiper>
          <!-- <incineratedPieChart v-if="tabIn === 'currentTillDates'" :cardDataincineration="cardDataincineration" /> -->
        </div>
        <div
          class="card w-full lg:w-[44%] border-2 border-color rounded-lg bg-white mt-10 lg:mt-0"
        >
          <incineratedCard :cardDataincineration="cardDataincineration" />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="mt-[130px] bg-white text-black text-center">
    Welcome to SHC&MED
  </div>
</template>
  
<script setup>
import Card from "@/components/Card.vue";
import BarChart from "@/components/ChartBar.vue";
import currentWeek from "@/components/CurrentWeek.vue";
import CurrentDay from "@/components/CurrentDay.vue";
import CurrentMonth from "@/components/CurrentMonth.vue";
// import CurrentTillProgress from '@/components/currenttillprogress.vue'
import CurrentTillDate from "@/components/CurrentTillDate.vue";
// import SelectHosptialIncinerated from '@/components/selectHospitalIncinerated.vue'
//imconerated chart
import CurrentMonthIncinerated from "@/components/incineratedChart/CurrentMonthIncinerated.vue";
import CurrentWeekIncinerated from "@/components/incineratedChart/currentWeekIncineratedChart.vue";
import incineratedPieChart from "@/components/incineratedPieChart";
import CurrentTillDateIncinerated from "@/components/incineratedChart/CurrentTillDateIncineratedChart.vue";
import CurrentDateIncineratedChart from "@/components/incineratedChart/CurrentDateIncineratedChart.vue";
import TrandingGraph from "@/components/TrandingGraphChart.vue";
import incineratedCard from "@/components/incineratorCard.vue";
import {
  ref,
  onMounted,
  onUpdated,
  onBeforeUnmount,
  computed,
  onUnmounted,
} from "vue";
import axiosInstance from "@/plugins/axios";
import $ from "jquery";
import "select2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
const pageLoader = ref(false);
import { Swiper, SwiperSlide } from "swiper/vue";
const modules = [Navigation, Autoplay, Pagination, EffectFade];
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
// import './style.css';
import { Navigation, Autoplay, Pagination, EffectFade } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
const selectDistrictid = ref("all");
const selectDistrict = ref([]);
const selectDistrictIN = ref([]);

const selectDistrictidIn = ref("all");
const hospital_ids = ref([]);
const countries = ref([]);
const countriesiN = ref([]);
const cardData = ref({});
const cardDataincineration = ref({});
const tranding = ref([]);
// const tabIn = ref('currentTillDates')
// const tabs = ref('currentyear')
const userData = JSON.parse(localStorage.getItem("authService"));

const isAdmin = ref(false);
onMounted(() => {
  // Check if user_group is "admin"
  if (userData.authData && userData.authData.user_group === "Admin") {
    isAdmin.value = true;
  }
});
const tabChange = (page) => {
  tabIn.value = page;
};

const onSwiper = (swiper) => {
  console.log(swiper);
};
// const onSlideChange = (swiper) => {
//   console.log('slide change',swiper);
// };

const pagination = {
  clickable: true,
  renderBullet: (index, className) =>
    `<span class="${className}">${index + 1}</span>`,
};
const tabIn = [
  "currentTillDateIncinerated",
  "currentTillDates",
  "currentMontIncinerated",
  "currentWeekIncinerated",
  "CurrentDateIncineratedChart",
];

const tabs = [
  "currenttill",
  "currentyear",
  "currentmonth",
  "currentweek",
  "currentday",
];
const activeTab = ref(tabs[0]);
const actibetabIn = ref(tabIn[0]);
const tab = (page) => {
  activeTab.value = page;
};
const onSlideChange = (swiper) => {
  if (swiper && swiper) {
    activeTab.value = tabs[swiper.activeIndex];
  }
};
const onSlideChange2 = (swiper) => {
  if (swiper && swiper) {
    actibetabIn.value = tabIn[swiper.activeIndex];
  }
};
const fetchDistrict = async () => {
  try {
    const response = await axiosInstance.get("/assigned-collection-districts"); // Replace with your API endpoint
    const districts = response.data.data;
    countryChanged();
    // Extracting all district names
    const districtNames = districts.map((district) => district);
    selectDistrict.value = districtNames;
  } catch (error) {
    console.error("Error fetching countries:", error);
    // Handle error or show error message
  }
};

const fetchDistrictIn = async () => {
  try {
    const response = await axiosInstance.get(
      "/assigned-incineration-districts"
    ); // Replace with your API endpoint
    const districts = response.data.data;
    countryChangedIn();
    // Extracting all district names
    const districtNames = districts.map((district) => district);
    selectDistrictIN.value = districtNames;
  } catch (error) {
    console.error("Error fetching countries:", error);
    // Handle error or show error message
  }
};

const countryChanged = async () => {
  try {
    const response = await axiosInstance.get(
      `/assigned-districts/${selectDistrictid.value}/collection-hospitals`
    );
    const countery = response.data.data;
    const counterys = countery.map((countery) => countery);
    countries.value = counterys;
  } catch (error) {
    console.error("Error fetching district info:", error);
    // Handle error or show error message
  }
};

const countryChangedIn = async () => {
  try {
    const response = await axiosInstance.get(
      `/assigned-districts/${selectDistrictidIn.value}/incineration-hospitals`
    );
    const countery = response.data.data;
    const counterys = countery.map((countery) => countery);
    countriesiN.value = counterys;
  } catch (error) {
    console.error("Error fetching district info:", error);
    // Handle error or show error message
  }
};

const fetchData = async () => {
  try {
    const response = await axiosInstance.post(
      "/dashboard/trending-graph-data",
      {
        district_id: selectDistrictid.value,
        hospital_ids: $("#hospitalsSelect1").val(),
      }
    );
    // console.log(response.data.data, 'API response');
    tranding.value = response.data.data;
  } catch (error) {
    console.error("Error fetching data from API:", error);
  }
};
// Assuming you have some logic to update hospital_ids when needed
const applyFilters = async (isapply) => {
  pageLoader.value = true;

  try {
    const response = await axiosInstance.post(
      "dashboard/waste-collected-vs-incinerated",
      {
        district_id: selectDistrictid.value,
        hospital_ids: $("#hospitalsSelect1").val(),
      }
    );
    cardData.value = response.data.data;
    fetchData();
    // console.log(response.data.data);
    // You can handle the response data as needed
  } catch (error) {
    console.error("Error fetching data:", error);
    pageLoader.value = false;
  }
  pageLoader.value = false;
};
const applyFiltersincineration = async (isapply) => {
  pageLoader.value = true;

  try {
    const response = await axiosInstance.post(
      "dashboard/incinerator-performance",
      {
        district_id: selectDistrictidIn.value,
        hospital_ids: $("#hospitalsSelect2").val(),
      }
    );
    cardDataincineration.value = response.data.data;
    // console.log(response.data.data);
    // You can handle the response data as needed
  } catch (error) {
    console.error("Error fetching data:", error);
    pageLoader.value = false;
  }
  pageLoader.value = false;
};
const clearFilter = async (e) => {
  selectDistrictid.value = "all";
  $("#hospitalsSelect1").val([]).trigger("change");
  // counteryid.value = []
  countryChanged();
  await applyFilters();
  await fetchData();
};
const clearFilterIn = async (e) => {
  selectDistrictidIn.value = "all";
  $("#hospitalsSelect2").val([]).trigger("change");
  countryChangedIn();
  await applyFiltersincineration();
  await fetchData();
};
$(document).ready(function () {
  // Initialize Select2 for Select 1
  $("#hospitalsSelect1").select2({
    placeholder: "All Hospitals",
    allowClear: true,
  });

  // Initialize Select2 for Select 2
  $("#hospitalsSelect2").select2({
    placeholder: "All Hospitals",
    allowClear: true,
  });
});

const formatNumber = (value) => {
  if (value !== undefined) {
    return value.toLocaleString();
  } else {
    return 0;
  }
};
import { useAuthService } from "@/store/Auth"; //  auth.js file
const authStore = useAuthService();
const permissions = ref([]);
onMounted(() => {
  const authData = authStore.authData;
  permissions.value = authStore.authData.permissions;
});
const hasDashboardPermission = computed(() =>
  permissions.value.some(
    (permission) => permission.name === "can view dashboard"
  )
);
onMounted(() => {
  if (hasDashboardPermission.value) {
    //  fetchData();
    fetchDistrict();
    fetchDistrictIn();
    applyFilters();
    applyFiltersincineration();

    // Execute the functions every 5 minutes (300,000 milliseconds)
    const intervalId = setInterval(() => {
      // fetchDistrict();
      // fetchDistrictIn();
      // fetchData();
      applyFilters();
      applyFiltersincineration();
      // console.log('5 minute dashboard refresh')
    }, 300000);

    // Clear the interval when the component is unmounted
    onBeforeUnmount(() => {
      clearInterval(intervalId);
    });
  }
});

onMounted(async () => {
  await authStore.handlepermission();
});

onUnmounted(async () => {
  await authStore.handlepermission();
});
</script>
  
<style>
@import "~select2/dist/css/select2.min.css";

.select2-container--default.select2-container--focus
  .select2-selection--multiple {
  border: solid #3f83f8 2px !important;
  outline: 0;
}
.select2-container--custom-theme
  .select2-selection--single
  .select2-selection__placeholder {
  color: #ff0000; /* Change this to your desired color */
}
.yellow {
  background: yellow !important;
}

span.select2-selection.select2-selection--multiple {
  padding: 8px !important;
  background: padding-box !important;
}

.select2-container--default .select2-selection--multiple {
  background-color: white;
  border: 1px solid #aaaaaa82 !important;
  border-radius: 4px;
  cursor: text;
  padding-bottom: 5px;
  padding-right: 5px;
  position: relative;
}

.swiper-button-next {
  color: black !important;
  border: 1px solid yellow;
  border-radius: 30px;
  padding: 1px 20px;
  background: yellow;
}

.swiper-button-next:after {
  font-family: swiper-icons;
  font-size: 15px !important;
  text-transform: none !important;
  letter-spacing: 0;
  font-variant: initial;
  line-height: 1;
}

.swiper-button-prev:after {
  font-family: swiper-icons;
  font-size: 15px !important;
  text-transform: none !important;
  letter-spacing: 0;
  font-variant: initial;
  line-height: 1;
}

.swiper-button-prev {
  color: black !important;
  border: 1px solid yellow;
  border-radius: 50px;
  padding: 1px 20px;
  background: yellow;
}

.select2-container--default
  .select2-selection--multiple
  .select2-selection__clear {
  cursor: pointer;
  font-weight: bold;
  height: 20px;
  margin-right: 10px;
  margin-top: 5px;
  position: absolute;
  right: 0;
  padding: 1px;
  display: none !important;
}
::placeholder {
  color: black !important;
  font-family: Nunito Sans !important;
  font-weight: 550 !important;
}
.select2-container .select2-search--inline .select2-search__field {
  box-sizing: border-box;
  border: none;
  font-size: 100%;
  margin-top: -24px;
  margin-left: 5px;
  padding: 0;
  max-width: 100%;
  resize: none;
  height: 23px !important;
  vertical-align: bottom;
  font-family: sans-serif;
  overflow: hidden;
  word-break: keep-all;
}

.swiper-pagination-bullet {
  border: 1px solid darkgray !important;
  color: black !important;
  width: var(
    --swiper-pagination-bullet-width,
    var(--swiper-pagination-bullet-size, 35px)
  );
  height: var(
    --swiper-pagination-bullet-height,
    var(--swiper-pagination-bullet-size, 35px)
  );
  display: inline-block;
  border-radius: var(--swiper-pagination-bullet-border-radius, 20%);
  background: white;
  opacity: none !important;
  /* padding: 19px; */
}

span.swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: yellow;
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal {
  bottom: var(--swiper-pagination-bottom, 0px);
  top: var(--swiper-pagination-top, auto);
  width: 100%;
  display: flex;
  justify-content: end;
  padding-right: 60px;
}

.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
  padding: 5px !important;
}
span.select2.select2-container.select2-container--default {
  background-color: white;
  font-weight: 500 !important;
  color: black !important;
}
@media screen and (max-width: 768px) {
  .swiper-button-prev:after {
    font-family: swiper-icons;
    font-size: 8px !important;
    text-transform: none !important;
    letter-spacing: 0;
    font-variant: initial;
    line-height: 1;
  }

  .swiper-button-prev {
    color: black !important;
    border: 1px solid yellow;
    border-radius: 50px;
    padding: 1px 15px;
    height: 35px;
    background: yellow;
  }

  .swiper-button-next {
    color: black !important;
    border: 1px solid yellow;
    border-radius: 30px;
    padding: 1px 15px;
    height: 35px;
    background: yellow;
  }

  .swiper-button-next:after {
    font-family: swiper-icons;
    font-size: 8px !important;
    text-transform: none !important;
    letter-spacing: 0;
    font-variant: initial;
    line-height: 1;
  }

  .swiper-pagination-bullet {
    border: 1px solid darkgray !important;
    color: black !important;
    width: var(
      --swiper-pagination-bullet-width,
      var(--swiper-pagination-bullet-size, 30px)
    );
    height: var(
      --swiper-pagination-bullet-height,
      var(--swiper-pagination-bullet-size, 30px)
    );
    display: inline-block;
    border-radius: var(--swiper-pagination-bullet-border-radius, 20%);
    background: white;
    opacity: none !important;
    /* padding: 19px; */
  }

  span.swiper-pagination-bullet.swiper-pagination-bullet-active {
    background: yellow;
  }
  .custom-placeholder-color {
    color: black !important;
  }
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: var(--swiper-pagination-bottom, 0px);
    top: var(--swiper-pagination-top, auto);
    width: 100%;
    display: flex;
    justify-content: center;
    padding-right: 0px !important;
  }

  .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
  .swiper-pagination-horizontal.swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
    padding: 3px !important;
  }
}

.border-color {
  border-color: #cdcdcd;
}
</style>